import { render, staticRenderFns } from "./fccGruSimples.vue?vue&type=template&id=18f8323b"
import script from "./fccGruSimples.vue?vue&type=script&lang=js"
export * from "./fccGruSimples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports